import { useClerk } from "@clerk/react";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * ADV-379: log ud af AIKA. Roller (fx CPR-adgang) læses kun ved login, så en ændret
 * gruppeindmeldelse virker først efter et nyt login. Næste login går via Microsoft-SSO.
 */
export function useLogout() {
  const { signOut } = useClerk();
  const queryClient = useQueryClient();
  return useCallback(async () => {
    queryClient.clear();
    await signOut({ redirectUrl: "/" });
  }, [signOut, queryClient]);
}
